import { ApiCrud } from 'adready-api/api/api-crud';
import http from 'adready-api/api/http';

const userApi = new ApiCrud(http.AXIOS, {
  listUsers: 'users?accountId=:accountId',
  listAdvertiserUsers: 'users/advertiser?advertiserId=:advertiserId',
});
export default userApi;
